import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAppSelector } from '../store/hooks';
import { ROUTES } from '../constants';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiresToken?: boolean;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requiresToken = true,
}) => {
  const { currentUser } = useAppSelector((state) => state.user);
  const location = useLocation();

  // Check if user is authenticated
  if (!currentUser) {
    return <Navigate to={ROUTES.LOGIN} state={{ from: location }} replace />;
  }

  // If this route requires a token and user doesn't have one,
  // redirect to settings (except if already on settings page)
  if (requiresToken && !currentUser.wb_api_token && location.pathname !== ROUTES.SETTINGS) {
    return <Navigate to={ROUTES.SETTINGS} replace />;
  }

  return <>{children}</>;
};
